module.exports = __webpack_public_path__ + "static/VanessaHyselA-2268f4216fe19435b4202cc7e11c934d.gif";